import React from 'react';
import theme from './SellerSidebar.module.scss';
import { faStars } from '@fortawesome/pro-light-svg-icons';
import { Button as RubusUiButton } from '@ygtechnologies/rubus-ui';
import { Trans } from '@lingui/react/macro';

export interface AddButtonProps {
    onClick: () => void;
}

export const AddButton: React.FC<AddButtonProps> = ({onClick}) => {
    return (
        <RubusUiButton onClick={onClick} className={theme.previewButton} icon={faStars}>
            <Trans>Add</Trans>
        </RubusUiButton>
    );
};
